import { render, staticRenderFns } from "./sign-request.vue?vue&type=template&id=4af042f8&"
import script from "./sign-request.vue?vue&type=script&lang=js&"
export * from "./sign-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports